/*
 * @Author: xiangheng
 * @Date: 2019-09-16 10:18:58
 * @LastEditors: xiangheng
 * @LastEditTime: 2019-09-19 17:49:48
 * @Description: file content
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/intellectQuality/qualityMonitor',
    name:'/qualityMonitor',
    meta:{
        title:'风险监控'
    },
    component: () =>
        import ( /* webpackChunkName: "example-intellectQuality" */ '../views/intellectQuality/qualityMonitor.vue')
  },
  {
    path: '/intellectQuality/qualityReport',
    name:'/qualityReport',
    meta:{
        title:'质检报告'
    },
    component: () =>
        import ( /* webpackChunkName: "example-intellectQuality" */ '../views/intellectQuality/qualityReport.vue')
  },
  {
    path: '/intellectQuality/qualityDetails',
    name:'/qualityDetails',
    meta:{
        title:'质检详情'
    },
    component: () =>
        import ( /* webpackChunkName: "example-intellectQuality" */ '../views/intellectQuality/qualityDetails.vue')
  },
  {
    path: '/intellectQuality/qualityCollocation',
    name:'/qualityCollocation',
    meta:{
        title:'质检配置'
    },
    component: () =>
        import ( /* webpackChunkName: "example-intellectQuality" */ '../views/intellectQuality/qualityCollocation.vue')
  },
  {
    path: '/intellectQuality/allQuality',
    name:'/allQuality',
    meta:{
        title:'全部质检'
    },
    component: () =>
        import ( /* webpackChunkName: "example-intellectQuality" */ '../views/intellectQuality/allQuality.vue')
  },
] 